import React from "react";
import { Box, Typography } from "@mui/material";
import discountPicture from "assets/discount.png";

const DiscountLogo = ({ discount, sx, fontSize, width }) => {
  if (discount > 0) {
    let formattedDiscount;

    const discountNumber = Number(discount); // nos aseguramos de que sea número

    if (Number.isInteger(discountNumber)) {
      formattedDiscount = discountNumber.toString(); // sin .00
    } else {
      formattedDiscount = discountNumber.toFixed(2); // con .00 si es decimal
    }


    return (
      <Box
        sx={{
          position: "relative",
          width: sx?.width || width || "200px", // Default width if not provided
          ...sx, // Spread the provided sx for custom styles
        }}
      >
        {/* Background image */}
        <img
          src={discountPicture}
          alt="Background"
          style={{ width: "100%", objectFit: "cover" }}
        />
        {/* Discount text */}
        <Typography
          component="div"
          sx={{
            position: "absolute",
            width: "100%",
            top: "50%",
            left: "50%",
            transform: "translate(-60%, -50%)",
            color: "white",
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: sx?.fontSize || fontSize || { xs: "1.1rem", md: "20px" }, // Default fontSize if not provided
            fontWeight: 900,
            textAlign: "center",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
          }}
        >
          -{formattedDiscount}% OFF
        </Typography>
      </Box>
    );
  } else {
    return null;
  }
};

export default DiscountLogo;
